import { VMain } from 'vuetify/lib/components/VMain';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VMain,[_c('TitleBar',{attrs:{"title":"視聴"}}),_c('transition',{attrs:{"name":"page"}},[_c('div',{staticClass:"video-container-wrap mx-auto"},[(_vm.videoParam !== null)?_c('VideoContainer',{attrs:{"videoParam":_vm.videoParam}}):_vm._e(),(_vm.recordedId !== null)?_c('WatchOnRecordedInfoCard',{attrs:{"recordedId":_vm.recordedId}}):_vm._e(),_c('div',{staticStyle:{"visibility":"hidden"}},[_vm._v("dummy")])],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }